import React, { useState, useEffect, useRef } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from "react-redux";
import NavbarMob from '../components/NavbarMob'
import Navbar from '../components/Navbar'
import FooterMob from '../components/FooterMob'
import Footer from '../components/Footer'
import filter from '../images/Products/filter.png'
import refreshimg from '../images/Products/refresh.png'
import product1 from '../images/Home/product2.webp'
import heart from '../images/Home/heart.png'
import filledHeart from '../images/Home/heart2.png';
import forward from '../images/Products/forwardpng.png'
import top from '../images/Products/top.png'
import Filter from '../components/Filter'
import axios from 'axios'

const PromotionTags = ({ product }) => {
    return (
        <div className="flex flex-wrap gap-1 mb-1">
            {product.BestSeller === 1 && (
                <span className="bg-orange-100 text-orange-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    Best Seller
                </span>
            )}
            {product.LimitedSale === 1 && (
                <span className="bg-rose-100 text-rose-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    Limited Sale
                </span>
            )}
            {product.NewArrivals === 1 && (
                <span className="bg-sky-100 text-sky-600 text-[9px] font-bold px-1.5 py-0.5 rounded-full uppercase tracking-wider">
                    New Arrival
                </span>
            )}
        </div>
    );
};

function SearchPage() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const isTab = useMediaQuery({ query: '(max-width: 1024px)' });
    const [colors, setColors] = useState([]);
    const [sizes, setSizes] = useState([]);
    const [loginId, setLoginId] = useState(null);

    // Optimized states from Home page technique
    const [allProducts, setAllProducts] = useState([]);
    const [visibleProducts, setVisibleProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [targetProductCount] = useState(100);

    // Filter states
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(10000);
    const [showFilter, setShowFilter] = useState(false);
    const [isPriceExpanded, setPriceExpanded] = useState(true);
    const [isColorsExpanded, setIsColorsExpanded] = useState(true);
    const [isSizeExpanded, setIsSizeExpanded] = useState(true);
    const [isDressExpanded, setIsDressExpanded] = useState(true);
    const [showFilterMob, setShowFilterMob] = useState(false);
    const location = useLocation();
    const [selectedItemName, setSelectedItemName] = useState('');
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [wishlistItems, setWishlistItems] = useState([]);

    // Pagination states (technique from Home page)
    const [nextRowOffset, setNextRowOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [totalProducts, setTotalProducts] = useState(0);
    const [currentApiUrl, setCurrentApiUrl] = useState('');
    const PAGE_SIZE = 20;

    const { filtered } = location.state || {};
    const navigate = useNavigate();

    // Refs for caching and mounting
    const imageCacheRef = useRef(new Map());
    const abortControllerRef = useRef(null);
    const mountedRef = useRef(true);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;
    const userId = useSelector((state) => state.user.id);

    // Cleanup on unmount
    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, []);

    // Get loginId from localStorage
    useEffect(() => {
        const storedLoginId = localStorage.getItem('loginId');
        setLoginId(storedLoginId);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Optimized: Check multiple images at once (from Home page)
    const checkImagesBatch = async (imageCodes) => {
        if (!imageCodes.length) return {};
        const batchSize = 30; // Increased from 10
        const results = {};

        for (let i = 0; i < imageCodes.length; i += batchSize) {
            const batch = imageCodes.slice(i, i + batchSize);
            const batchPromises = batch.map(async (code) => {
                if (imageCacheRef.current.has(code)) {
                    return { code, exists: imageCacheRef.current.get(code) };
                }

                try {
                    const res = await fetch(
                        `${apiLocalUrl}/check-image/${encodeURIComponent(code)}`
                    );

                    if (!res.ok) {
                        imageCacheRef.current.set(code, false);
                        return { code, exists: false };
                    }

                    const data = await res.json();
                    imageCacheRef.current.set(code, data.exists);
                    return { code, exists: data.exists };

                } catch (err) {
                    imageCacheRef.current.set(code, false);
                    return { code, exists: false };
                }
            });

            const batchResults = await Promise.all(batchPromises);
            batchResults.forEach(result => {
                results[result.code] = result.exists;
            });

            // No delay between internal batches for speed
        }

        return results;
    };

    // Optimized: Get available color for a product (from Home page)
    const getAvailableColorForProduct = async (productId) => {
        try {
            const response = await axios.get(`${apiBaseUrl}/getProductDetails/BLACKBATON_2526?Id=${productId}`);
            if (response.status === 200) {
                const data = response.data;
                const distinctColorsArr = [...new Set(
                    data.filter(item => item.ItemId === productId).map(item => item.Color?.trim()).filter(Boolean)
                )];

                const colorCodes = distinctColorsArr.map(color => `${productId}_${color}.webp`);
                const colorResults = await checkImagesBatch(colorCodes);

                for (const color of distinctColorsArr) {
                    const code = `${productId}_${color}.webp`;
                    if (colorResults[code]) {
                        return color;
                    }
                }
                return null;
            }
        } catch (error) {
            console.error('Error:', error);
            return null;
        }
    };

    // Optimized: Check if image exists for a product (from Home page)
    const checkImageExists = async (product) => {
        try {
            const imageCodesToCheck = [];

            if (product.displayFirst) {
                const displayFirstCode = `${product.displayFirst}.webp`;
                imageCodesToCheck.push(displayFirstCode);
            }

            const imageResults = await checkImagesBatch(imageCodesToCheck);

            if (product.displayFirst) {
                const displayFirstCode = `${product.displayFirst}.webp`;
                if (imageResults[displayFirstCode]) {
                    return { exists: true, code: displayFirstCode, color: null };
                }
            }

            const color = await getAvailableColorForProduct(product.ID);
            if (color) {
                const colorCode = `${product.ID}_${color}.webp`;
                return { exists: true, code: colorCode, color };
            }

            return { exists: false, code: null, color: null };
        } catch (error) {
            console.error('Error checking image:', error);
            return { exists: false, code: null, color: null };
        }
    };

    // Optimized: Process products in batches (from Home page)
    const processProductsBatch = async (products, batchSize = 20) => {
        const validProducts = [];

        for (let i = 0; i < products.length && validProducts.length < targetProductCount; i += batchSize) {
            const batch = products.slice(i, i + batchSize);

            const batchPromises = batch.map(async (product) => {
                if (!product) return null;
                
                // If backend already validated
                if (product.hasValidImage) {
                    return product;
                }

                try {
                    const imageCheck = await checkImageExists(product);
                    if (imageCheck.exists) {
                        return {
                            ...product,
                            displayFirst: imageCheck.code?.replace('.webp', '') || product.displayFirst
                        };
                    }
                } catch (err) {
                    console.error('Error checking product', product?.ID, err);
                }
                return null;
            });

            const batchResults = await Promise.all(batchPromises);
            const validBatchProducts = batchResults.filter(Boolean);

            validProducts.push(...validBatchProducts);

            // Update UI with new products immediately
            if (mountedRef.current && validBatchProducts.length > 0) {
                setAllProducts(prev => {
                    const newProducts = validBatchProducts.filter(newProd =>
                        !prev.some(p => p.ID === newProd.ID)
                    );
                    return [...prev, ...newProducts];
                });

                if (mountedRef.current) {
                    setVisibleProducts(prev => {
                        const newIds = validBatchProducts
                            .map(p => p.ID)
                            .filter(id => !prev.includes(id));
                        return [...prev, ...newIds];
                    });
                }
            }

            if (i + batchSize < products.length && validProducts.length < targetProductCount) {
                await new Promise(resolve => setTimeout(resolve, 0));
            }
        }

        return validProducts;
    };

    // Optimized: Fetch products with batched processing (from Home page)
    const fetchProductsWithAvailability = async () => {
        if (!apiBaseUrl) return;
        setLoadingProducts(true);
        setAllProducts([]);
        setVisibleProducts([]);
        imageCacheRef.current.clear();

        // Reset pagination
        setNextRowOffset(0);
        setHasMore(true);

        const params = new URLSearchParams();
        params.append('filter', filtered);
        params.append('minPrice', minPrice);
        params.append('maxPrice', maxPrice);
        if (selectedColor) params.append('color', selectedColor);
        if (selectedSize) params.append('size', selectedSize);

        if (abortControllerRef.current) abortControllerRef.current.abort();
        const controller = new AbortController();
        abortControllerRef.current = controller;
        const signal = controller.signal;

        const baseUrl = `${apiBaseUrl}/getProductByFilter/BLACKBATON_2526?${params.toString()}`;
        setCurrentApiUrl(baseUrl);

        try {
            const response = await fetch(`${baseUrl}&page=1&pageSize=${PAGE_SIZE}`, {
                signal: signal
            });

            if (!response.ok) throw new Error(`API request failed with status ${response.status}`);

            const result = await response.json();
            const initialProducts = result.products || (Array.isArray(result) ? result : []);

            // Update pagination info
            setNextRowOffset(result.pagination?.nextRowOffset || 0);
            setHasMore(result.pagination?.hasMore || false);
            setTotalProducts(result.pagination?.totalProducts || 0);

            // Remove duplicates by ID
            const uniqueProducts = initialProducts.filter((product, index, self) =>
                index === self.findIndex(p => p.ID === product.ID)
            );

            // Process products in batches with optimization
            await processProductsBatch(uniqueProducts, 20);

            if (uniqueProducts.length > 0 && !selectedItemName && mountedRef.current) {
                setSelectedItemName(uniqueProducts[0].ItemName);
            }
        } catch (error) {
            if (error.name === 'AbortError') return;
            console.error('Error fetching products:', error);
        } finally {
            if (mountedRef.current && !signal.aborted) setLoadingProducts(false);
        }
    };

    // New: Load more products function (technique from Home page)
    const loadMoreProducts = async () => {
        if (!apiBaseUrl || isLoadingMore || !hasMore || !currentApiUrl) return;

        setIsLoadingMore(true);
        const offsetParam = `&nextRowOffset=${nextRowOffset}`;

        if (abortControllerRef.current) abortControllerRef.current.abort();
        const controller = new AbortController();
        abortControllerRef.current = controller;
        const signal = controller.signal;

        try {
            const response = await fetch(`${currentApiUrl}${offsetParam}&pageSize=${PAGE_SIZE}`, {
                signal: signal
            });
            const result = await response.json();

            if (result.products && Array.isArray(result.products)) {
                // Update pagination state
                setNextRowOffset(result.pagination?.nextRowOffset || 0);
                setHasMore(result.pagination?.hasMore || false);

                // Process new products in batches
                await processProductsBatch(result.products, 8);
            }
        } catch (error) {
            if (error.name === 'AbortError') return;
            console.error('Error loading more products:', error);
        } finally {
            if (mountedRef.current && !signal.aborted) setIsLoadingMore(false);
        }
    };

    // New: Add scroll listener for infinite scrolling (technique from Home page) - REMOVED
    // useEffect(() => {
    //     const handleScroll = () => {
    //         if (!isLoadingMore && hasMore && allProducts.length > 0) {
    //             if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 1000) {
    //                 loadMoreProducts();
    //             }
    //         }
    //     };
    //     // ...
    // }, [isLoadingMore, hasMore, allProducts.length, currentApiUrl, nextRowOffset]);

    // Fetch products on component mount or search term change
    useEffect(() => {
        fetchProductsWithAvailability();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filtered]);

    // Simplified: No more client-side filtering needed for price
    useEffect(() => {
        setFilteredProducts(allProducts);
    }, [allProducts]);

    // Optimized wishlist functions
    const addToWishlist = async (product) => {
        const apiUrl = `${apiBaseUrl}/wishlist/add/BLACKBATON_2526`;
        const activeUserId = loginId || userId;

        if (!activeUserId) {
            alert("Please login to add items to wishlist");
            return;
        }

        const payload = {
            ID: product.ID,
            ItemName: product.ItemName,
            MRP: product.MRP,
            ledcode: activeUserId,
            Qty: product.Qty,
            uniqueCode: product.UniqueCode
        };

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                setWishlistItems(prev => [...prev, product]);
            } else {
                alert("Already in Wishlist");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred");
        }
    };

    useEffect(() => {
        if (!mountedRef.current) return;

        const fetchWishlistItems = async () => {
            try {
                const activeUserId = loginId || userId;
                if (!activeUserId) return;

                const response = await fetch(`${apiBaseUrl}/wishlist/items/BLACKBATON_2526/${activeUserId}`);
                const data = await response.json();

                if (data.success && mountedRef.current) {
                    setWishlistItems(data.items);
                }
            } catch (error) {
                console.error("Error fetching wishlist items:", error);
            }
        };

        fetchWishlistItems();
    }, [loginId, apiBaseUrl, userId]);

    const removeFromWishlist = async (productId) => {
        try {
            const response = await fetch(`${apiBaseUrl}/wishlist/delete/BLACKBATON_2526/${productId}`, {
                method: 'DELETE',
            });

            if (response.ok && mountedRef.current) {
                setWishlistItems(prev => prev.filter(item => item.ID !== productId));
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    // Fetch categories and other data
    useEffect(() => {
        if (!mountedRef.current) return;

        const fetchInitialData = async () => {
            try {
                const [categoriesRes, subCategoriesRes, colorSizeRes] = await Promise.all([
                    fetch(`${apiBaseUrl}/getCategories/BLACKBATON_2526`),
                    fetch(`${apiBaseUrl}/getSubCategories/BLACKBATON_2526`),
                    fetch(`${apiBaseUrl}/getAllColorSize/BLACKBATON_2526`)
                ]);

                const [categoriesData, subCategoriesData, colorSizeData] = await Promise.all([
                    categoriesRes.json(),
                    subCategoriesRes.json(),
                    colorSizeRes.json()
                ]);

                if (mountedRef.current) {
                    setCategories(categoriesData);
                    setSubCategories(subCategoriesData);

                    const uniqueColors = [...new Set(colorSizeData.map(item => item.Color))];
                    const uniqueSizes = [...new Set(colorSizeData.map(item => item.Size))];
                    setColors(uniqueColors);
                    setSizes(uniqueSizes);
                }
            } catch (error) {
                console.error('Error fetching initial data:', error);
            }
        };

        fetchInitialData();
    }, [apiBaseUrl]);

    // Stable filter handler
    const handleFilterAction = async (apiUrl) => {
        if (!mountedRef.current) return;

        try {
            setLoadingProducts(true);
            setAllProducts([]);
            setVisibleProducts([]);

            // Reset pagination for the new filter
            setNextRowOffset(0);
            setHasMore(true);
            setCurrentApiUrl(apiUrl);

            const response = await fetch(`${apiUrl}${apiUrl.includes('?') ? '&' : '?'}page=1&pageSize=${PAGE_SIZE}`);
            const result = await response.json();

            const productsList = result.products || (Array.isArray(result) ? result : []);

            // Update pagination info
            if (result.pagination) {
                setNextRowOffset(result.pagination.nextRowOffset || 0);
                setHasMore(result.pagination.hasMore || false);
                setTotalProducts(result.pagination.totalProducts || 0);
            } else {
                setHasMore(false);
            }

            const uniqueProducts = productsList.filter((product, index, self) =>
                index === self.findIndex(p => p.ID === product.ID)
            );

            await processProductsBatch(uniqueProducts, 20);
        } catch (error) {
            console.error('Error:', error);
        } finally {
            if (mountedRef.current) {
                setLoadingProducts(false);
            }
        }
    };

    const handleSubCategoryClick = (subCategoryId) => {
        handleFilterAction(
            `${apiBaseUrl}/getProductBySubCategory/BLACKBATON_2526?Id=${subCategoryId}`
        );
    };

    const handleCategoryClick = (categoryId) => {
        handleFilterAction(
            `${apiBaseUrl}/getProductByCategory/BLACKBATON_2526?Id=${categoryId}`
        );
    };

    const handleColorClick = (color) => {
        const newColor = selectedColor === color ? null : color;
        setSelectedColor(newColor);

        const params = new URLSearchParams();
        params.append('filter', filtered);
        params.append('minPrice', minPrice);
        params.append('maxPrice', maxPrice);
        if (newColor) params.append('color', newColor);
        if (selectedSize) params.append('size', selectedSize);

        let url = `${apiBaseUrl}/getProductByFilter/BLACKBATON_2526?${params.toString()}`;
        handleFilterAction(url);
    };

    const handleSizeClick = (size) => {
        const newSize = selectedSize === size ? null : size;
        setSelectedSize(newSize);

        const params = new URLSearchParams();
        params.append('filter', filtered);
        params.append('minPrice', minPrice);
        params.append('maxPrice', maxPrice);
        if (selectedColor) params.append('color', selectedColor);
        if (newSize) params.append('size', newSize);

        let url = `${apiBaseUrl}/getProductByFilter/BLACKBATON_2526?${params.toString()}`;
        handleFilterAction(url);
    };

    // Add: Handle price filter application
    const handlePriceFilterApply = () => {
        const params = new URLSearchParams();
        params.append('filter', filtered);
        params.append('minPrice', minPrice);
        params.append('maxPrice', maxPrice);
        if (selectedColor) params.append('color', selectedColor);
        if (selectedSize) params.append('size', selectedSize);

        let url = `${apiBaseUrl}/getProductByFilter/BLACKBATON_2526?${params.toString()}`;
        handleFilterAction(url);
    };

    // Helper function to check if product is visible (from Home page)
    const isProductVisible = (productId) => {
        return visibleProducts.includes(productId);
    };

    // Get image URL with fallback (from Home page)
    const getProductImageUrl = (product) => {
        if (product.displayFirst) {
            return `${apiLocalUrl}/uploads/${product.displayFirst}.webp`;
        }
        return product1;
    };

    // Rest of the component functions...
    const handleMinChange = (e) => {
        const value = Math.min(Number(e.target.value), maxPrice - 10);
        setMinPrice(value);
    };

    const handleMaxChange = (e) => {
        const value = Math.max(Number(e.target.value), minPrice + 10);
        setMaxPrice(value);
    };

    const handleApplyFilters = (filters) => {
        if (filters.subCategory) {
            handleSubCategoryClick(filters.subCategory);
        }
        if (filters.category) {
            handleCategoryClick(filters.category);
        }
        if (filters.color) {
            filters.color.forEach(color => handleColorClick(color));
        }
        if (filters.size) {
            filters.size.forEach(size => handleSizeClick(size));
        }
        if (filters.priceRange) {
            setMinPrice(filters.priceRange.minPrice);
            setMaxPrice(filters.priceRange.maxPrice);
        }
    };

    const toggleFilter = () => setShowFilter(!showFilter);
    const closeFilter = () => setShowFilter(!showFilter);
    const togglePrice = () => setPriceExpanded(!isPriceExpanded);
    const toggleColors = () => setIsColorsExpanded(!isColorsExpanded);
    const toggleSize = () => setIsSizeExpanded(!isSizeExpanded);
    const toggleDress = () => setIsDressExpanded(!isDressExpanded);
    const handleFilterClick = () => setShowFilterMob(true);
    const closeFilterMob = () => setShowFilterMob(false);

    function encodeBase64(text) {
        return btoa(text);
    }

    const fullimage = (id, itemName) => {
        navigate(`/fullimage?I=${encodeBase64(String(id))}&N=${encodeBase64(itemName)}`, { state: { id, itemName } });
    };

    const refresh = () => {
        window.location.reload()
    };

    // Determine which products to display based on filters
    const productsToDisplay = filteredProducts.length > 0 ? filteredProducts : allProducts;

    return (
        <div className='min-h-screen bg-white text-black font-montserrat'>
            {isMobile ? <NavbarMob /> : <Navbar />}

            <div className='w-full max-w-[1440px] mx-auto lg:px-12 px-4 py-8 flex flex-col gap-8 lg:mt-[160px] md:mt-[140px] mt-[60px] pb-20'>
                {/* Breadcrumbs */}
                <div className='flex items-center gap-2 text-sm'>
                    <span className='text-gray-400 cursor-pointer hover:text-black transition-colors' onClick={() => navigate('/')}>Home</span>
                    <span className='text-gray-300'>/</span>
                    <span className='text-black font-semibold'>Search Results</span>
                </div>

                <div className='flex flex-col lg:flex-row gap-10'>
                    {/* Desktop Sidebar Filter */}
                    {showFilter && (
                        <aside className='hidden lg:flex flex-col w-[280px] shrink-0 gap-8'>
                            <div className='flex items-center justify-between pb-4 border-b border-gray-100'>
                                <h2 className='text-xl font-bold'>Filters</h2>
                                <button onClick={closeFilter} className='text-gray-400 hover:text-black'>
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                                </button>
                            </div>

                            {/* Subcategories */}
                            <div className='flex flex-col gap-4'>
                                <h3 className='font-bold text-sm uppercase tracking-wider text-gray-400'>Categories</h3>
                                <div className='flex flex-col gap-2'>
                                    {subCategories.map((sub) => (
                                        <button
                                            key={sub.Id}
                                            onClick={() => handleSubCategoryClick(sub.Id)}
                                            className='text-left text-sm hover:text-gray-600 transition-colors py-1'
                                        >
                                            {sub.Name}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Price Filter */}
                            <div className='flex flex-col gap-4 pt-4 border-t border-gray-50'>
                                <div className='flex items-center justify-between cursor-pointer group' onClick={togglePrice}>
                                    <h3 className='font-bold group-hover:text-gray-600 transition-colors'>Price Range</h3>
                                    <svg className={`w-4 h-4 transition-transform duration-300 ${isPriceExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                                </div>
                                {isPriceExpanded && (
                                    <div className='flex flex-col gap-6 pt-2'>
                                        <div className="w-full relative flex items-center h-2 bg-gray-100 rounded-full">
                                            <input type="range" min="0" max="10000" step="10" value={minPrice} onChange={handleMinChange} className="absolute z-20 appearance-none w-full h-full bg-transparent pointer-events-auto cursor-pointer" style={{ accentColor: "black" }} />
                                            <input type="range" min="0" max="10000" step="10" value={maxPrice} onChange={handleMaxChange} className="absolute z-20 appearance-none w-full h-full bg-transparent pointer-events-auto cursor-pointer" style={{ accentColor: "black" }} />
                                            <div className="absolute h-full bg-black rounded-full" style={{ left: `${(minPrice / 10000) * 100}%`, right: `${100 - (maxPrice / 10000) * 100}%` }}></div>
                                        </div>
                                        <div className='flex items-center justify-between gap-4'>
                                            <div className='flex-1 p-2 bg-gray-50 border border-gray-100 rounded-lg text-center text-sm font-semibold'>₹{minPrice}</div>
                                            <div className='flex-1 p-2 bg-gray-50 border border-gray-100 rounded-lg text-center text-sm font-semibold'>₹{maxPrice}</div>
                                        </div>
                                        <button
                                            onClick={handlePriceFilterApply}
                                            className='w-full py-2 bg-black text-white text-sm font-bold rounded-lg hover:bg-gray-800 transition-all'
                                        >
                                            Apply Price
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* Colors */}
                            {/* <div className='flex flex-col gap-4 pt-4 border-t border-gray-50'>
                                <div className='flex items-center justify-between cursor-pointer group' onClick={toggleColors}>
                                    <h3 className='font-bold group-hover:text-gray-600 transition-colors'>Colors</h3>
                                    <svg className={`w-4 h-4 transition-transform duration-300 ${isColorsExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                                </div>
                                {isColorsExpanded && (
                                    <div className='grid grid-cols-5 gap-3 pt-2'>
                                        {colors.map((color, index) => (
                                            <button
                                                key={index}
                                                onClick={() => handleColorClick(color)}
                                                className={`w-8 h-8 rounded-full border ${selectedColor === color ? 'border-black ring-2 ring-gray-200' : 'border-gray-100'}`}
                                                style={{ backgroundColor: color }}
                                                title={color || 'N/A'}
                                            />
                                        ))}
                                    </div>
                                )}
                            </div> */}

                            {/* Sizes */}
                            {/* <div className='flex flex-col gap-4 pt-4 border-t border-gray-50'>
                                <div className='flex items-center justify-between cursor-pointer group' onClick={toggleSize}>
                                    <h3 className='font-bold group-hover:text-gray-600 transition-colors'>Sizes</h3>
                                    <svg className={`w-4 h-4 transition-transform duration-300 ${isSizeExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                                </div>
                                {isSizeExpanded && (
                                    <div className='flex flex-wrap gap-2 pt-2'>
                                        {sizes.map((size, index) => (
                                            <button
                                                key={index}
                                                onClick={() => handleSizeClick(size)}
                                                className={`px-3 py-1.5 text-xs font-bold rounded-lg border transition-all ${selectedSize === size ? 'bg-black text-white border-black' : 'bg-white text-black border-gray-100 hover:border-black'}`}
                                            >
                                                {size}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div> */}
                        </aside>
                    )}

                    {/* Product Grid Area */}
                    <main className='flex-1'>
                        <div className='flex items-center justify-between mb-8'>
                            <h1 className='text-2xl font-bold'>
                                {filtered ? `Search: "${filtered}"` : "All Products"}
                                {/* <span className='ml-2 text-sm font-normal text-gray-400'>({totalProducts} products)</span> */}
                            </h1>
                            <div className='flex items-center gap-4'>
                                <button onClick={refresh} className='p-2 hover:bg-gray-50 rounded-full transition-colors' title="Refresh">
                                    <img src={refreshimg} alt="refresh" className='w-5 h-5' />
                                </button>
                                <button onClick={toggleFilter} className='lg:flex hidden items-center gap-2 px-4 py-2 bg-black text-white rounded-full text-sm font-bold hover:bg-gray-800 transition-all'>
                                    <img src={filter} alt="filter" className='w-4 h-4 brightness-0 invert' />
                                    {showFilter ? 'Hide Filters' : 'Show Filters'}
                                </button>
                                <button onClick={handleFilterClick} className='lg:hidden p-2 hover:bg-gray-50 rounded-full transition-colors'>
                                    <img src={filter} alt="filter" className='w-5 h-5' />
                                </button>
                            </div>
                        </div>

                        {loadingProducts && productsToDisplay.length === 0 ? (
                            <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-10'>
                                {[...Array(4)].map((_, i) => (
                                    <div key={i} className='flex flex-col gap-4 animate-pulse' style={{ opacity: 1 - i * 0.25 }}>
                                        <div className='aspect-[3/4] bg-gray-100 rounded-2xl' />
                                        <div className='h-4 w-3/4 bg-gray-100 rounded-full' />
                                        <div className='h-4 w-1/4 bg-gray-100 rounded-full' />
                                    </div>
                                ))}
                            </div>
                        ) : productsToDisplay.length === 0 ? (
                            <div className='flex flex-col items-center justify-center py-20 text-center gap-4 animate-in fade-in duration-500'>
                                <div className='w-20 h-20 bg-gray-50 rounded-full flex items-center justify-center mb-2'>
                                    <svg className="w-10 h-10 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                                </div>
                                <h2 className='text-xl font-bold text-gray-900'>No products found</h2>
                                <p className='text-gray-500 font-medium max-w-md'>We couldn't find any products matching your search criteria. Try using different keywords.</p>
                                <button onClick={() => navigate('/')} className='mt-4 px-8 py-3 bg-black text-white rounded-xl font-bold hover:bg-gray-800 transition-all shadow-lg hover:shadow-xl'>Back to Shopping</button>
                            </div>
                        ) : (
                            <div className='flex flex-col gap-12'>
                                <div className={`grid gap-x-5 gap-y-10 ${showFilter ? "grid-cols-2 md:grid-cols-2 lg:grid-cols-3" : "grid-cols-2 md:grid-cols-3 lg:grid-cols-4"}`}>
                                    {productsToDisplay.map((product) => {
                                        const isVisible = isProductVisible(product.ID);
                                        const isInWishlist = wishlistItems.some(item => item.ID === product.ID);

                                        return (
                                            <div key={product.ID}
                                                className={`group flex flex-col gap-3 cursor-pointer transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                                                onClick={() => fullimage(product.ID, product.ItemName)}
                                            >
                                                <div className='relative aspect-[3/4] rounded-2xl bg-[#F5F5F7] overflow-hidden'>
                                                    <img
                                                        src={getProductImageUrl(product)}
                                                        alt={product.ItemName}
                                                        className='w-full h-full object-cover transition-transform duration-700 group-hover:scale-105'
                                                        loading="lazy"
                                                        onError={(e) => { e.target.src = product1; }}
                                                    />
                                                    <button
                                                        className={`absolute top-4 right-4 w-10 h-10 rounded-full shadow-sm flex items-center justify-center transition-all ${isInWishlist ? 'bg-black text-white' : 'bg-white/80 backdrop-blur-sm text-black hover:bg-white'}`}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            isInWishlist ? removeFromWishlist(product.ID) : addToWishlist(product);
                                                        }}
                                                    >
                                                        <img src={isInWishlist ? filledHeart : heart} alt="wishlist" className={`w-5 h-5 ${isInWishlist ? 'brightness-0 invert' : ''}`} />
                                                    </button>
                                                </div>
                                                <div className='flex flex-col gap-1'>
                                                    <PromotionTags product={product} />
                                                    <h3 className='text-left text-sm font-bold truncate group-hover:underline underline-offset-4'>{product.ItemName}</h3>
                                                    <div className='flex items-center gap-2'>
                                                        <span className='font-bold'>₹{product.MRP}</span>
                                                        {/* {product.MOP > 0 && product.MOP < product.MRP && (
                                                            <span className='text-xs text-gray-400 line-through'>₹{product.MOP}</span>
                                                        )} */}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {isLoadingMore && (
                                    <div className='flex justify-center py-8'>
                                        <div className='w-8 h-8 border-4 border-black border-t-transparent rounded-full animate-spin' />
                                    </div>
                                )}

                                {!isLoadingMore && hasMore && productsToDisplay.length > 0 && (
                                    <div className='flex justify-center py-8'>
                                        <button
                                            onClick={loadMoreProducts}
                                            className='px-8 py-3 bg-black text-white text-sm font-bold rounded-full hover:bg-gray-800 transition-all transform hover:scale-105 shadow-lg'
                                        >
                                            Load More Products
                                        </button>
                                    </div>
                                )}

                                {/* {!hasMore && productsToDisplay.length > 0 && (
                                    <div className='text-center py-10 border-t border-gray-100'>
                                        <p className='text-gray-400 text-sm italic'>End of collection</p>
                                    </div>
                                )} */}
                            </div>
                        )}
                    </main>
                </div>
            </div>

            {showFilterMob && <Filter closeFilterMob={closeFilterMob} onApply={handleApplyFilters} />}
            {isTab ? <FooterMob /> : <Footer />}
        </div>
    );
}

export default SearchPage;